import { render, staticRenderFns } from "./newscontent.vue?vue&type=template&id=01d60e9a&scoped=true&"
import script from "./newscontent.vue?vue&type=script&lang=js&"
export * from "./newscontent.vue?vue&type=script&lang=js&"
import style0 from "./newscontent.vue?vue&type=style&index=0&id=01d60e9a&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d60e9a",
  null
  
)

export default component.exports